import axios from "axios";

const getMemberList = (setLoading, setRows) => {
  axios
    .get(`/api/user/list`)
    .then(response => {
      const responseArr = response.data;

      if (responseArr.length > 0) {
        setLoading(false);
      }
      responseArr.forEach(element => {
        element.id = element.member_id;
        console.log(element);
      });
      console.log(`RESPONSE LA LIST MEMBERS: `, responseArr);
      return setRows(() => responseArr);
    })
    .catch(error => {
      console.error(`Error la axios /api/user/list`, error);
    });
};

export default getMemberList;
